import { defineComponent as _defineComponent } from 'vue'
import {
  availableDashboardLayouts,
  DashboardLayout,
} from '@/models/Charts/dashboardDefinition';
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import { WidgetEnum } from '@/models/enums/WidgetEnum';
import { dateRangeToDateStrings } from '@/utils/dates';
import { indexedWidgetDefinitions } from '@/utils/misc';
import LayoutGrid from '@/views/dashboard/LayoutGrid.vue';
import WidgetContainer from '@/components/Charts/widgetContainer/WidgetContainer.vue';
import { computed, ref, watch } from 'vue';
import { FilterTimeSpanEnum } from '@/models/enums/FilterTimeSpanEnum';


export default /*#__PURE__*/_defineComponent({
  __name: 'BendTrends',
  props: {
    selectedDevices: null,
    dateRange: null,
    selectedShifts: null,
    selectedTimeAxisSpan: null,
    selectedTimespan: null
  },
  setup(__props: any) {

const props = __props as {
  selectedDevices: string[];
  dateRange: [Date, Date];
  selectedShifts: number[];
  selectedTimeAxisSpan: FilterTimeAxisSpanEnum;
  selectedTimespan: FilterTimeSpanEnum;
};



// The computed property is moved here because otherwise `dateRangeString` is undefined
// when `createWidgetDefinitions` is called below.
const dateRangeString = computed<[string, string]>(() =>
  dateRangeToDateStrings(props.dateRange),
);

const widgetDefinitions = ref<WidgetDefinition[]>(createWidgetDefinitions());

const gridLayout = availableDashboardLayouts[DashboardLayout.TwoByThree];

function createWidgetDefinitions(): WidgetDefinition[] {
  return indexedWidgetDefinitions([
    new WidgetDefinition(
      WidgetEnum.BendingAvailabilityHist,
      props.selectedDevices,
      dateRangeString.value,
      props.selectedShifts,
      undefined,
      props.selectedTimeAxisSpan,
    ),
    new WidgetDefinition(
      WidgetEnum.BendStatus,
      props.selectedDevices,
      undefined,
      [],
    ),
    new WidgetDefinition(
      WidgetEnum.BendingTimeBetweenBendHist,
      props.selectedDevices,
      dateRangeString.value,
      props.selectedShifts,
      undefined,
      props.selectedTimeAxisSpan,
    ),
    new WidgetDefinition(
      WidgetEnum.BendingPerformancePartHist,
      props.selectedDevices,
      dateRangeString.value,
      props.selectedShifts,
      undefined,
      props.selectedTimeAxisSpan,
    ),
    new WidgetDefinition(
      WidgetEnum.BendingPerformance,
      props.selectedDevices,
      props.selectedTimespan,
      props.selectedShifts,
    ),
    new WidgetDefinition(
      WidgetEnum.BendingPerformanceHist,
      props.selectedDevices,
      dateRangeString.value,
      props.selectedShifts,
      undefined,
      props.selectedTimeAxisSpan,
    ),
  ]);
}

function replaceWidgetDefinition(
  index: number,
  widgetDefinition: WidgetDefinition,
) {
  widgetDefinitions.value.splice(index, 1, widgetDefinition);
}

function updateWidgetDefinitions() {
  widgetDefinitions.value = widgetDefinitions.value.map((widgetDefinition) =>
    widgetDefinition.getCopy({
      deviceId: props.selectedDevices,
      timeFilter:
        widgetDefinition.widget === WidgetEnum.BendingPerformance
          ? props.selectedTimespan
          : dateRangeString.value,
      shifts: props.selectedShifts,
      axisSpan: props.selectedTimeAxisSpan,
    }),
  );
}

watch(
  () => [
    props.selectedDevices,
    props.dateRange,
    props.selectedShifts,
    props.selectedTimeAxisSpan,
    props.selectedTimespan,
  ],
  () => {
    updateWidgetDefinitions();
  },
);

return { __sfc: true,props, dateRangeString, widgetDefinitions, gridLayout, createWidgetDefinitions, replaceWidgetDefinition, updateWidgetDefinitions, LayoutGrid, WidgetContainer }
}

})